module.exports = __webpack_public_path__ + "img/activity-2@2x.bb32e2f2.svg";